<template>
    <div class="box">
        <div class="box-left">
            <div class="line">
                <a @click.stop="closeNav" class=" handel-header">
                    <local-svg class="icon hover" iconClass="navbtn" :class="{ 'acthaer': isClose }"></local-svg>
                </a>
            </div>
            <span class="header-bread" v-if="nav.hasChild">{{nav.navFather}}&nbsp;&nbsp;/&nbsp;&nbsp;<span class="header-bread-son">{{ nav.navChild }}</span></span>
            <span class="header-bread header-bread-son" v-else>{{nav.navFather}}</span>
        </div>
        
        <div class="line2">
            <div class="user avatar-handel">
                <img v-if="$store.state.userimage" class="user-avatar" :src="`${imgURL}${$store.state.userimage}`" alt="" style="border-radius: 50%;">
                <img v-else class="user-avatar" src="../assets/image/user.jpg" alt="" style="border-radius: 50%;">
                <el-popover placement="bottom" title="" width="96" popper-class="showbox popover-element-change hover" trigger="click">
                    <div class="showbox">
                        <div class="showbox-list" @click="toPersonal">个人中心</div>

                        <div @click="logout" class="showbox-list">退出登录</div>
                    </div>
                    <button class="button hover" slot="reference">{{ $store.state.username }} <local-svg class="user-show hover" iconClass="admindown"></local-svg></button>
                </el-popover>
                
            </div>
            <div class="iconlist">
                <div class="">
                    <a @click="refsh" class="handel-header">
                        <local-svg class="list-image hover " iconClass="newload"></local-svg>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vm from '@/assets/js/closeNav'
export default {
    name: "Header",
    props: {
        list: {
            type: Array,
            default: () => {
                return []
            }
        },
    },
    data() {
        return {
            info: {
                avatar: require('../assets/image/user.png'),
                name: this.$store.state.username,
            },
            imgURL: process.env.VUE_APP_IMG_URL,
            actindex: 0,
            isClose: false,
            tabList: [],
            visible: true,
            mineList: [
                { name: '个人中心', path: '/personal' },
                { name: '退出登录', path: '/personal' },
            ],
            totalMessage: '',
            noticeList: [],
            systemList: [],
            timer: null,
            nav:{
                hasChild:false,
                navFather:'',
                navChild:""
            },
            currentMenu:'',
        };
    },
    mounted() {
        this.currentMenu = this.$route.path
        this.getActNavbar()
        this.getTab()
        console.log(this.$store.state)
    },
    methods: {
        getActNavbar(){
            let child_list = [] 
            this.list.forEach(item => {
                if(!item.has_child){
                    child_list.push(item.path)
                }
            });
            if(child_list.indexOf(this.currentMenu)>-1){
                this.list.forEach( item =>{
                    if(item.path == this.currentMenu){
                        this.nav.navFather = item.title
                        this.nav.navChild = ''
                        this.nav.hasChild = false
                    }
                })
            }else{
                this.list.forEach( item =>{
                    if(item.has_child == 1){
                        item.page.forEach( child_item =>{
                            if(child_item.path==this.currentMenu){
                                this.nav.navChild = child_item.title
                                this.nav.navFather = child_item.breadcrumb_father
                                this.nav.hasChild = true
                            }
                        })
                    }
                })
            }
        },
        toPersonal() {
            this.$router.push({
                path: '/personal'
            })
            this.nav={
                hasChild:false,
                navFather:'个人中心',
                navChild:""
            }
        },
        refsh() {
            this.$router.go(0);
        },  
        closeNav() {
            if (this.isClose) {
                this.isClose = false
            } else {
                this.isClose = true
            }
            let type = this.isClose
            vm.$emit("closetype", type)
        },
        getTab() {
            vm.$on('closeobj', value => {
                if(value.breadcrumb_father){
                    this.nav.navChild = value.title
                    this.nav.navFather = value.breadcrumb_father
                    this.nav.hasChild = true
                }else{
                    this.nav.navFather = value.title
                    this.nav.navChild = ''
                    this.nav.hasChild = false
                }
            })
        },
        logout() {
            localStorage.removeItem('TOKEN')
            localStorage.removeItem('userimage')
            localStorage.removeItem('username')
            this.$router.push('/login')
        }
    },
}
</script>

<style lang="scss">
.el-popover {
    min-width: 96px !important;
}

.showbox {
    padding: 8px 0;
}

.el-drawer__open .el-drawer.rtl {
    width: 480px !important;
}

.messageBox {
    padding: 0 !important;

    // width: 480px;
    .el-badge__content {
        background-color: #F33232 !important;
    }

    .el-badge__content {
        border: none;
        font-weight: normal !important;
        height: 16px;
        line-height: 16px;
        padding: 0 4px;
        border-radius: 8px;
        min-width: 8px;
    }

    .el-badge__content.is-fixed {
        right: 0 !important;
    }
}

.iconlist {
    .el-badge__content {
        background-color: #F33232 !important;
    }

    .el-badge__content {
        border: none;
        font-weight: normal !important;
        height: 16px;
        line-height: 16px;
        padding: 0 4px;
        border-radius: 8px;
        min-width: 8px;
    }

    .el-badge__content.is-fixed {
        right: 37px !important;
    }
}
</style>
<style lang="scss" scoped>
* {
    text-align: center;
    box-sizing: border-box;
}

.box {
    width: 100%;
    height: 60px;
    background: #fff;
    padding: 0;
    display: flex;
    justify-content: space-between;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
    position: relative;
    z-index: 999;

    .messageBox::-webkit-scrollbar {
        display: none;
    }
    .box-left{
        display: flex;
        line-height: 60px;
        .header-bread{
            font-size: 14px;
            color: #9A9EAA;
            margin-left: 24px;
        }
        .header-bread-son{
            color: #353940 !important;
        }
        .line {
            display: flex;
            align-items: center;
            justify-content:  center;
            height: 60px;
            width: 64px;
            border-right: 1px solid #F0F1F5;
            .handel .icon {
                color: #9A9EAA;
            }

            .icon {
                font-size: 20px;
            }

            .tab-list {
                display: flex;
                margin-left: 30px;

                .list-box {
                    height: 60px;
                    color: #B0B1B9;
                    font-size: 14px;
                    line-height: 16px;
                    width: 108px;
                    display: flex;
                    align-items: center;
                    border-top: white 4px solid;

                    .box-msg {
                        display: flex;
                        justify-content: center;
                        height: 16px;
                        width: 100%;
                        border-right: 1px solid #e6e6e6;

                        .box-close {
                            width: 14px;
                            height: 14px;
                            background: #E6E6E6;
                            display: flex;
                            border-radius: 50%;
                            margin-left: 8px;

                            .img {
                                width: 6px;
                                height: 6px;
                                margin: auto;
                            }
                        }
                    }

                }

                .list-box:last-child {
                    .box-msg {
                        border: none;
                    }
                }

                .acttab {
                    color: #2C57FF !important;
                    background: #F4F7FC;
                    border-top: #2C57FF 4px solid;

                    .box-close {
                        background: rgba(44, 87, 255, 0.2) !important;

                        .svg-icon {
                            fill: #2C57FF !important;
                        }
                    }

                    .box-msg {
                        border-right: 1px solid F4F7FC;
                    }
                }
            }
        }
    }
    

    .line2 {
        width: 300px;
        height: 60px;
        display: flex;
        flex-direction: row-reverse;

        .user {
            width: auto;
            border-left: #F0F1F5 solid 1px;
            height: 100%;
            padding: 0 0 0 30px;
            text-align: left;
            display: flex;
            align-items: center;

            .user-avatar {
                width: 36px;
                height: 36px;
                margin-right: 14px;
            }

            .user-show {
                width: 10px;
                margin-left: 6px;
                margin-right: 30px;
            }

            .button {
                background: transparent;
                border: none;
                outline: none;
                font-size: 14px;
                line-height: 16px;
                white-space: nowrap // width: auto;
                    // display: flex;
                    // flex-wrap: nowrap;
            }
        }

        .avatar-handel {
            button {
                color: #B0B1B9;
            }

            .svg-icon {
                fill: #B0B1B9;
            }
        }

        .avatar-handel:hover {
            button {
                color: #1D78FE !important;
            }

            .svg-icon {
                fill: #1D78FE !important;
            }
        }

        .iconlist {
            display: flex;
            align-items: center;
            flex-direction: row-reverse;

            .more-box {
                height: 20px;
                display: flex;
                align-items: center;
            }

            .list-image {
                width: 20px;
                height: 18px;
                margin-right: 30px;
            }

            .msg {
                width: 18px;
                height: 20px;
            }

            // .more{
            //     width: 20px;
            //     height: 4px;
            // }
            .button {
                background: transparent;
                background-size: 100% 100%;
                border: none;
                outline: none;
                display: flex;
                align-items: center;
            }

        }
    }

    .headtab {
        display: flex;
        justify-content: center;
        box-sizing: border-box;
        padding: 28px 0 0px 0;

        .tab-box {
            display: flex;
            justify-content: space-between;
            width: 100%;
            font-size: 14px;
            border-bottom: 1px solid #F0F1F5;
            box-sizing: content-box;
            height: 32px;

            .tab {
                color: #B0B1B9;
                height: 100%;
                width: 180px;
            }

            .tab:hover {
                color: #2C57FF;
            }

            .acttab {
                font-weight: bold !important;
                color: #2C57FF !important;
                border-bottom: 2px solid #2C57FF !important;
                width: 180px;
                height: calc(100% + 2px);
            }
        }
    }

    .msg-list {
        padding: 8px 31px 8px 48px;
        text-align: left;
        height: calc(100vh - 140px);
        overflow-y: auto;

        .msg {
            padding: 16px 0;
            border-bottom: 1px #EAECF5 dashed;

            .msg-top {
                display: flex;
                justify-content: space-between;
                line-height: 22px;

                .msg-title {
                    font-size: 14px;
                    font-weight: bold;
                    display: flex;
                    align-items: center;
                    position: relative;
                    color: #6B6D77;

                    .msg-point {
                        width: 8px;
                        height: 8px;
                        border-radius: 50%;
                        background: #F33232;
                        position: absolute;
                        left: -18px;
                    }
                }

                .msg-date {
                    font-size: 12px;
                    color: #B0B1B9;
                }
            }

            .msg-main {
                text-align: left;
                margin-top: 16px;
                color: #B0B1B9;
                font-size: 14px;
                line-height: 22px;
            }

            .report {
                text-align: left;
                color: #B0B1B9;
                font-size: 14px;
                line-height: 22px;
                position: relative;

                .msg-point {
                    width: 8px;
                    height: 8px;
                    border-radius: 50%;
                    background: #F33232;
                    position: absolute;
                    left: -18px;
                    top: 6px;
                }
            }
        }

        .msg:last-child {
            border: none;
        }

        .msg1 {
            padding: 16px 0;
            border-bottom: 1px #EAECF5 dashed;
            display: flex;
            justify-content: space-between;
            align-items: center;
            line-height: 22px;

            .msg1-main {
                text-align: left;
                width: 276px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 14px;
                color: #6B6D77;
            }

            .msg1-date {
                font-size: 12px;
                color: #B0B1B9;
            }
        }
    }

    .msg-bottom {
        border-top: 1px solid #F0F1F5;
        width: 100%;
        height: 100%;
        padding: 20px 30px 0;
        display: flex;
        justify-content: space-between;
        flex-direction: row-reverse;

        .msg-more {
            font-size: 14px;
        }

        .msg-clear {
            font-size: 14px;
            display: flex;
            align-items: center;

            .img1 {
                margin-right: 8px;
            }
        }
    }

}

.showbox {
    .showbox-list {
        width: 100%;
        height: 36px;
        color: #9CA3B6;
        line-height: 36px;
        font-size: 14px;
    }
}

.acthaer {
    transform: rotate(180deg);
}

@import "@/assets/scss/flex.scss"</style>
